import { useState, useEffect } from 'react';
import { ThumbsUpImage } from '@/modules/order/components/OrderConfirmation/components/ThumbsUpImage';
import { Button, Link as LinkComponent } from '@schuettflix/react-components';
import { Link } from 'react-router';
import clsx from 'clsx';
import { useNavigate } from 'react-router';
import { getPositionOrderDetailsMonolithRoute, getPositionOverviewMonolithRoute } from '@/shared/utils/positionRoutes';
import { useTranslation } from 'react-i18next';
import { useMonolithFrontendUrl } from '@/shared/hooks/useMonolithFrontendUrl';

interface DirectFulfillmentConfirmationProps {
    orderNumber: string;
    orderId: string;
    positionId: string;
    constructionProjectId: string;
}

export const DirectFulfillmentConfirmation: React.FC<DirectFulfillmentConfirmationProps> = props => {
    const [isMounted, setIsMounted] = useState(false);

    const { url: urlPositionOrderDetails } = useMonolithFrontendUrl({
        path: getPositionOrderDetailsMonolithRoute(props.constructionProjectId, props.positionId, props.orderId),
    });
    const { url: urlPositionOverview } = useMonolithFrontendUrl({
        path: getPositionOverviewMonolithRoute(props.constructionProjectId, props.positionId),
    });

    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        setIsMounted(true);
    }, []);

    return (
        <div
            className={clsx(
                'bg fixed z-50 flex h-screen w-screen justify-center transition-opacity duration-500 ease-in-out',
                {
                    'opacity-100': isMounted,
                    'opacity-0': !isMounted,
                }
            )}
        >
            <div className="mt-[144px] flex flex-col items-center">
                <ThumbsUpImage />
                <h2 className="font-headline-xl-strong mb-2 mt-6">
                    {t('fulfillment.directFulfillment.confirmation.title', { orderNumber: props.orderNumber })}
                </h2>
                <p>{t('fulfillment.directFulfillment.confirmation.subtitle')}</p>
                <p>
                    <span>{t('fulfillment.directFulfillment.confirmation.moreInformation')}</span>
                    <Link to={urlPositionOrderDetails}>
                        <LinkComponent
                            virtual
                            label={t('fulfillment.directFulfillment.confirmation.detailPage')}
                            className="ml-2 font-bold"
                        />
                    </Link>
                </p>
                <div className="mt-6 flex items-center gap-6">
                    <Link to={urlPositionOverview}>
                        <LinkComponent
                            virtual
                            label={t('fulfillment.directFulfillment.confirmation.goToOverview')}
                            className="font-bold"
                        />
                    </Link>
                    <Button
                        label={t('fulfillment.directFulfillment.confirmation.newDirectFulfillment')}
                        size="sm"
                        variant="secondary"
                        className="font-bold"
                        onClick={() => {
                            void navigate(`/position/${props.positionId}/fulfillment`);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
